// extracted by css-extract-rspack-plugin
export default {"simpleLayout":"SimpleLayout-module__simpleLayout__F6i9w"};